module.exports = __webpack_public_path__ + "static/media/dendro.27b1a938.webp";